import React from 'react';
import { Button } from 'reactstrap';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import SetStaffPermissionsPageContent from '../PageContent/SetStaffPermissionsPageContent';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';

const SetStaffPermissions = () => {
    const UserInfoBtn = <span className="pl-3"><Button className="link-btn" style={{ backgroundColor: '#1CABA8', color: 'white', border: 'none' }} size="sm" href="https://support.datecodegenie.com/users/datecodegenie-user-types" target="_blank">View User Types</Button></span>;
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="lg">
            <PageTitle
                heading="Set DateCodeGenie Manager & User Permissions"
                subheading="Pick which level fits your business workflow. You can always change this later from your portal."
                optionalRight={UserInfoBtn}
            />
            <SectionDivider width="70%" />
            <SetStaffPermissionsPageContent />
        </HeaderAndBodyLayout>
    );
};


export default SetStaffPermissions;

